// src/components/Services.jsx

import React from 'react';

const Investment = () => {
  return (
      <div className="flex flex-col items-center justify-center h-screen bg-white">
        <h2 className="text-4xl font-bold text-black mb-5">
          Investment Requiremnet, Valuation, and<span className="text-[#680099] ml-2 font-bold">Equity Offering</span>
        </h2>

        <h2 className="text-4xl font-bold text-black mb-5">
          Revealing <span className="text-[#680099] ml-2 font-bold">Soon!</span>
        </h2>


        {/*<ul style={bulletPointsStyle}>*/}
        {/*  <li style={bulletPointItemStyle}> <strong>Investment Rquirement: </strong> ₹1.65 Crore</li>*/}
        {/*  <li style={bulletPointItemStyle}> <strong>Company Valuation: </strong>₹30 Crore  </li>*/}
        {/*  <li style={bulletPointItemStyle}> <strong>Equity Offering: </strong> 5.5% for ₹1.65 Crore </li>*/}

        {/*</ul>*/}


        {/*/!* Container for the two boxes *!/*/}
        {/*<div style={boxesContainerStyle}>*/}
        {/*  /!* Left box *!/*/}
        {/*  <div style={leftBoxStyle}>*/}
        {/*    <div style={boxHeadingStyle}>Category</div>*/}
        {/*    <p style={leftboxContentStyle}> Platform Developement</p>*/}
        {/*    <p style={leftboxContentStyle}> Market Acquisition</p>*/}
        {/*    <p style={leftboxContentStyle}> Personnel Expansion</p>*/}
        {/*    <p style={leftboxContentStyle}> Forex SetUp & Compliance</p>*/}
        {/*    <p style={leftboxContentStyle}> Operational Expenses</p>*/}


        {/*  </div>*/}

        {/*  /!* middle box *!/*/}
        {/*  <div style={midBoxStyle}>*/}
        {/*    <div style={boxHeadingStyle}>Allocation (₹ Lakhs)</div>*/}
        {/*    <p style={midboxContentStyle}> 40</p>*/}
        {/*    <p style={midboxContentStyle}> 30</p>*/}
        {/*    <p style={midboxContentStyle}> 50</p>*/}
        {/*    <p style={midboxContentStyle}> 20</p>*/}
        {/*    <p style={midboxContentStyle}> 25</p>*/}
        {/*  </div>*/}

        {/*  /!* Right box *!/*/}
        {/*  <div style={rightBoxStyle}>*/}
        {/*    <div style={boxHeadingStyle}>Purpose</div>*/}
        {/*    <p style={boxContentStyle}>Feature Exapnsion, API Integration, And Customization Improvements.</p>*/}
        {/*    <p style={rightboxContentStyle}>Digital Marketing, Agent Onbaording Incentives, And Brand Establishment.</p>*/}
        {/*    <p style={rightboxContentStyle}>Key Hires In Technology, Support, And Business Developement.</p>*/}
        {/*    <p style={rightboxContentStyle}>FFMC License Compliance And Forex Service Setup.</p>*/}
        {/*    <p style={rightboxContentStyle}>Office Setup, Legal Complaince, And Infrastructure Costs.</p>*/}

        {/*  </div>*/}
        {/*</div>*/}


      </div>
  );
};

const bulletPointsStyle = {
  listStyleType: 'disc',  // Bullet points (disc)
  paddingLeft: '20px',    // Indentation for the list
  marginTop: '20px',      // Space above the list
  };
  
  const bulletPointItemStyle = {
    fontSize: '18px',       // Font size for the bullet point text
    marginBottom: '10px',   // Space between each bullet point
    lineHeight: '1.6',      // Line height for readability
  };

const boxesContainerStyle = {
  display: 'flex',  // Align items side by side
  gap: '20px',  // Space between the boxes
  marginTop: '19px',  // Optional: space between heading and boxes

};

const leftBoxStyle = {
  flex: 1,  // Takes up available space, but narrower due to specific width
  maxWidth: '20%',  // Adjust width to make it narrower
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',
};

const midBoxStyle = {
  flex: 1,  // Takes up available space, but narrower due to specific width
  maxWidth: '28%',  // Adjust width to make it narrower
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',
  
};

const rightBoxStyle = {
  flex: 1,  // Takes up available space
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',
  maxWidth: '52%',  // Adjust width to make it narrower

};

const boxHeadingStyle = {
  backgroundColor: '#321e5d',  // Background color for the heading
  color: 'white',
  padding: '10px',
  borderRadius: '30px 30px 0px 0px',   
  fontSize: '18px',
  fontWeight: 'bold',  
  textAlign: 'center',

  
};

const boxContentStyle = {
  
  textAlign: 'center',
  marginTop: '20px',
  fontSize: '18px',
  marginBottom: '50px'

};


const leftboxContentStyle = {
  
  textAlign: 'center',
  fontSize: '18px',
  marginTop: '20px',
  marginBottom: '55px'

};
const midboxContentStyle = {
  
    textAlign: 'center',
    fontSize: '18px',
    marginTop: '20px',
    marginBottom: '56px'
  };

const rightboxContentStyle = {
  
  textAlign: 'center',
  fontSize: '18px',
  marginBottom: '45px',
  // marginTop: '20px',


};


export default Investment;
